var map = {
	"./404.png": "89da",
	"./appeal.png": "b430",
	"./arrow-gray.svg": "935d",
	"./arrow-home.svg": "da03",
	"./arrow-icon-banner.svg": "3f40",
	"./arrow-slider-prev.svg": "cb44",
	"./arrow-slider.svg": "7cb2",
	"./arrow-up.svg": "5200",
	"./arrow.svg": "3c0a",
	"./bakery.svg": "fcf7",
	"./banner-icons.svg": "382f",
	"./banner-text.svg": "1bfb",
	"./banner-wings.svg": "1e06",
	"./best_price-icon-black.svg": "08e1",
	"./best_price-icon-white.svg": "3040",
	"./best_price-icon.svg": "df759",
	"./book-icon.svg": "c8f0",
	"./bookmark.svg": "4e1b",
	"./check-icon.svg": "1564",
	"./checked.svg": "8ab9",
	"./circle.svg": "bcfb",
	"./close-btn.svg": "4cd9",
	"./close-white.svg": "0349",
	"./close.svg": "6282",
	"./coffee.svg": "166a",
	"./complexity.svg": "5957",
	"./coordinates.svg": "754f",
	"./discount.svg": "38d6",
	"./eye.svg": "45c2",
	"./favicon.svg": "91b5",
	"./fb.png": "5b9c",
	"./filter-gray.svg": "fa46",
	"./filter-red.svg": "eaf8",
	"./filter-white.svg": "a5c0",
	"./filter.svg": "8e90",
	"./fish.svg": "f116",
	"./img_placeholder.svg": "f7d7",
	"./insta.png": "a723",
	"./juice.svg": "4906",
	"./link.svg": "7c12",
	"./logo-footer-uz.svg": "db93",
	"./logo-footer.svg": "1771",
	"./logo-mobile.svg": "7caa",
	"./logo.svg": "aa0d",
	"./magnum-chef.svg": "adff",
	"./magnum-club__logo.svg": "457a",
	"./magnum-corp.svg": "66c4",
	"./magnum-go-logo.svg": "a0a5",
	"./magnum-pdf.svg": "7273",
	"./mandarin.svg": "f7a3",
	"./meat.svg": "9eaf",
	"./menu-btn.svg": "b4ac",
	"./next-orange.svg": "f430",
	"./next-purple.svg": "b7b9",
	"./next-red.svg": "d196",
	"./next-white-red.svg": "8189",
	"./next-white.svg": "8847",
	"./next.svg": "fc55",
	"./ok.png": "7fad",
	"./ornament.svg": "ae0f",
	"./placeholder.svg": "421e",
	"./prev-white.svg": "82bb",
	"./prev.svg": "fba8",
	"./print.svg": "6feb",
	"./quote.svg": "4373",
	"./red-arrow-left.svg": "926c",
	"./scroll-top-arrow.svg": "4321",
	"./search-pink.svg": "0f38",
	"./search.svg": "0930",
	"./shops-arrow-gray.svg": "4dd9",
	"./shops-arrow.svg": "d785",
	"./sort-icon.svg": "daa0",
	"./telegram.png": "4b82",
	"./tiktok.png": "c694",
	"./tomato.svg": "79fa",
	"./twitter.png": "9e04",
	"./views-gray.svg": "2ab1",
	"./vk.png": "4a70",
	"./whatsapp.png": "77b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65a8";